import React, { useState, useEffect } from 'react';
import Reporte_inventario_vivero_detalle from './Reporte_inventario_vivero_detalle';

const ReportePorFecha = (p) => {
    const data_send = p.data_send ?? {};
    let reporte = p.reporte ?? [];
    const dia = p.dia ?? '';
    const semana = p.semana ?? '';
    const [openDetalles, setopenDetalles] = useState(false);

    return (
        <>
            <div className='text-center shadow m-0 p-2 bg-light round-s col-xl-5 m-1 mb-3' style={{ overflowY: 'auto' }}>
                <div className='w-100 p-1 m-0 text-orange4 h3 dosis text-center'>REP. GENERAL INVENTARIO DE VIVERO</div>
                <table className='table table-sm table-striped'>
                    <thead>
                        <tr >
                            <th scope='col' className='text-start bg-orange4 text-white round-top-left-s'>CONCEPTO</th>
                            <th scope='col' className='text-center bg-orange4 text-white'>SEMANA<span className='text-xs ms-2 text-bold'>{semana}</span></th>
                            <th scope='col' className='text-center bg-orange4 text-white round-top-right-s'>Dia<span className='text-xs ms-2 text-bold'>{dia}</span></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            reporte.map((rep, i) =>
                                <tr key={`reporte-${i}`} >
                                    <th className="text-start align-middle ps-2">
                                        <div className="col-lg-12 d-flex align-items-center ">
                                            {rep.nombre}
                                        </div>
                                    </th>
                                    <td className='border-end' style={{ lineHeight: '1' }}>
                                        <div className='row justify-content-evenly w-100 m-0 p-0'>
                                            {
                                                rep.semana.map((semana, j) =>
                                                    <div key={`semana-${j} - ${i}`} className='col-lg-11 m-0 p-0 mb-2 mt-2 text-start border-bottom text-bold'>
                                                        {semana.value.toLocaleString('en-US')}
                                                        <span className='text-xs ms-2 text-500'>{semana.tipo}</span>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </td>
                                    <td className='border-end' style={{ lineHeight: '1' }}>
                                        <div className='row justify-content-evenly w-100 m-0 p-0'>
                                            {
                                                rep.dia.map((dia, j) =>
                                                    <div key={`dia-${j} - ${i}`} className='col-lg-11 m-0 p-0 mb-2 mt-2 text-start text-bold border-bottom'>
                                                        {dia.value.toLocaleString('en-US')}
                                                        <span className='text-xs ms-2 text-500'>{dia.tipo}</span>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
                <div className='w-100 text-center mb-3'>
                    <button className='btn btn-dark btn-sm shadow bw-400' onClick={() => setopenDetalles(true)}>DETALLES POR BLOQUE</button>
                </div>
            </div>
            {openDetalles && <Reporte_inventario_vivero_detalle close={() => setopenDetalles(false)} data_send={data_send} dia={dia} semana={semana} />}
        </>

    )
}

export default ReportePorFecha;